import qs from "qs";
import ApiClient, { ApiClientPromiseResponse } from "services/ApiClient";
import { Notification } from "types/notification";

class NotificationService extends ApiClient {
  getInboxNotificationsList(onlyNew = false): ApiClientPromiseResponse<Notification[]> {
    const query: { isShowOnlyNew?: boolean } = {};

    if (onlyNew) {
      query.isShowOnlyNew = true;
    }

    return this.call<Notification[]>({
      method: "get",
      url: `/notifications/inbox?${qs.stringify(query)}`,
    });
  }

  markAsViewed(notificationId: string): ApiClientPromiseResponse<{ id: string }> {
    return this.call<{ id: string }>({
      method: "put",
      url: `/notifications/${notificationId}/mark-as-viewed`,
    });
  }

  acknowledgeAssignment(notificationId: string): ApiClientPromiseResponse<{ id: string }> {
    return this.call<{ id: string }>({
      method: "put",
      url: `/notifications/${notificationId}/acknowledge-assignment`,
    });
  }

  developmentCreateNotification() {
    return this.call({
      method: "get",
      url: "/seed/generate-notification",
    });
  }
}

export default new NotificationService();
